import api from "../axios";

const getTenant = () => {
  return sessionStorage.getItem("acc_id");
};

/**
 * Get notifications for a user
 * @param {string} receiverId - The user ID to get notifications for
 * @returns {Promise} Response data containing notifications
 */
export async function getNotifications(receiverId) {
  const tenant = getTenant();
  const response = await api.get(`/notifications/${tenant}/`, {
    params: {
      receiver_id: receiverId,
    },
  });
  return response.data;
}

/**
 * Mark a single notification as read
 * @param {string} notificationId - The notification ID to mark as read
 * @returns {Promise} Response data
 */
export async function markNotificationAsRead(notificationId) {
  const tenant = getTenant();
  const response = await api.patch(
    `/notifications/${tenant}/${notificationId}/`
  );
  return response.data;
}

/**
 * Mark all notifications as read for the current tenant
 * @param {string} receiverId - The user ID to mark all notifications as read for
 * @returns {Promise} Response data
 */
export async function markAllNotificationsAsRead(receiverId) {
  const tenant = getTenant();
  const response = await api.patch(
    `/notifications/${tenant}/all-read/`,
    {},
    {
      params: {
        receiver_id: receiverId,
      },
    }
  );
  return response.data;
}
